export default [
  // 客服-工单评价
  {
    path: '/customerService/evaluation',
    name: 'customerService-evaluation',
    hidden: true,
    component: () => import('@/views/customerService/Evaluation.vue'),
    meta: {
      auth: 0,
    },
  },
  {
    path: '/service-cozeService-previewer-:botId-:token',
    component: () => import('@/views/customerService/cozeService/Previewer.vue'),
    name: 'service.cozeService.previewer',
    meta: {
      title: 'COZE预览',
      auth: 0,
      backgroundClass: 'bg-white',
    },
  },
];
